import moment from 'moment';
import Cookies from 'universal-cookie';

const getEndDayWithTimeZone = (date) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  return moment.tz(date, timezone).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ');
};

export default getEndDayWithTimeZone;
